module.exports = __webpack_public_path__ + "img/pc2.e5732276.png";